import { render, staticRenderFns } from "./BlockTracking.vue?vue&type=template&id=4c0f8a0e&"
import script from "./BlockTracking.vue?vue&type=script&lang=ts&"
export * from "./BlockTracking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports